module.exports = __webpack_public_path__ + "img/face6.07adc9a9.jpg";